<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>Edit Data Stream</div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <v-flex>
          <v-layout>
            <v-flex>
              <div class="subtitle-2 mb-1">What's the Content of the Pin?</div>
              <v-textarea
                rows="3"
                :rules="rules"
                v-model="content"
                dense
                outlined
                counter
                maxlength="200"
                placeholder="Pin Content"
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout v-if="igPermLink != ''">
            <v-flex>
              <v-btn
                color="primary"
                target="_blank"
                :href="igPermLink"
                class="text-none subtitle-2"
              >
                Go to post
                <v-icon class="ml-2">
                  mdi-instagram
                </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>

          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Schedule At</div>
              <v-text-field
                readonly
                v-model="scheduledAtDateString"
                hide-details
                dense
                outlined
                placeholder="Scheduled Date"
                @click="openScheduleDateDialog"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1" xs6>
              <div class="subtitle-2 mb-1">Expires In</div>
              <v-select
                dense
                hide-details
                placeholder="Expires In"
                outlined
                v-model="expiryRange"
                :items="expiryRanges"
                @change="onExpiryDateSelected"
                no-data-text="Please select a Schedule Time first"
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3" v-if="expiresAtDateString">
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Expires At</div>
              <v-text-field
                v-model="expiresAtDateString"
                readonly
                hide-details
                dense
                outlined
                placeholder="Expire Date"
                @click="openExpiryDateDialog"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout class="mt-3">
            <div class="subtitle-1 font-weight-medium">Pin Options</div>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Entity</div>
              <v-combobox
                :loading="loading"
                v-model="entity"
                :items="reviewedEntities"
                cache-items
                :search-input.sync="searchTerm"
                hide-details
                return-object
                item-text="title"
                item-value="title"
                placeholder="Select Entity"
                no-data-text="Type a name of an entity to search"
                outlined
                chips
                dense
                @change="entitySelected"
              ></v-combobox>
            </v-flex>
          </v-layout>
          <v-layout>
            <!-- {{ entity }} -->
            <v-btn
              v-if="entity.instagram"
              icon
              target="_blank"
              :href="entity.instagram"
            >
              <v-icon>mdi-instagram </v-icon>
            </v-btn>
            <v-btn
              v-if="entity.facebook"
              icon
              target="_blank"
              :href="entity.facebook"
            >
              <v-icon>mdi-facebook </v-icon>
            </v-btn>
            <v-btn
              v-if="entity.website"
              icon
              target="_blank"
              :href="entity.website"
            >
              <v-icon>mdi-globe </v-icon>
            </v-btn>
          </v-layout>
          <v-layout>
            <v-checkbox
              v-model="hasCustomLocation"
              label="Use a custom location"
            ></v-checkbox>
          </v-layout>
          <v-layout v-if="hasCustomLocation">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Latitude</div>
              <v-text-field
                outlined
                dense
                v-model="latitude"
                placeholder="Latitude"
              >
              </v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Longitude</div>
              <v-text-field
                outlined
                dense
                v-model="longitude"
                placeholder="Longitude"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Region</div>
              <v-select
                outlined
                dense
                hide-details
                return-object
                :items="regions"
                v-model="region"
                item-text="name"
                placeholder="Region"
              >
              </v-select>
            </v-flex>
          </v-layout>

          <!-- <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Entity</div>
              <v-select
                outlined
                dense
                hide-details
                return-object
                :items="reviewedEntities"
                v-model="entity"
                item-text="title"
                placeholder="Region"
              >
              </v-select>
            </v-flex>
          </v-layout> -->
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Pin Type</div>
              <v-autocomplete
                outlined
                dense
                hide-details
                return-object
                :items="pinTypes"
                v-model="pinType"
                item-text="name"
                placeholder="Pin Type"
                chips
              >
              </v-autocomplete>
            </v-flex>
          </v-layout>

          <v-layout class="mt-3">
            <v-flex xs6 class="mr-1">
              <div class="subtitle-2 mb-1">Link Name</div>
              <v-text-field
                v-model="linkName"
                hide-details
                dense
                outlined
                placeholder="Link Name"
              ></v-text-field>
            </v-flex>

            <v-flex xs6 class="ml-1">
              <div class="subtitle-2 mb-1">Link URL</div>
              <v-text-field
                v-model="linkUrl"
                hide-details
                dense
                outlined
                placeholder="Ex: http://..."
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout class="mt-3" v-if="attachment && !igPermLink">
            <v-flex>
              <div class="subtitle-2 mb-1">
                Attachment (Download and Re-Upload Required)
              </div>
              <v-hover v-slot="{ hover }">
                <v-card color="black" width="100">
                  <a
                    :href="attachment"
                    :title="attachment"
                    :download="attachment"
                    target="_blank"
                  >
                    <v-img
                      aspect-ratio="1"
                      :src="attachment"
                      :lazy-src="attachment"
                    >
                      <v-expand-transition>
                        <div
                          v-if="hover"
                          class="d-flex justify-center transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text"
                          style="height: 100%; opacity: 0.6"
                        >
                          <v-icon color="white"> mdi-file-download </v-icon>
                        </div>
                      </v-expand-transition>
                    </v-img>
                  </a>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>

          <!-- <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">is Marker?</div>
              <v-text-field
                v-model="isMarker"
                hide-details
                dense
                outlined
                placeholder="Ex: Bool"
              ></v-text-field>
            </v-flex>
          </v-layout> -->
          <gallery-image-select-section
            ref="galleryImageSelectSectionRef"
            @imageSelected="galleryImageSelected"
          />
          <v-layout v-if="imageUrl && !selectedFromGallery" class="mt-3">
            <v-flex>
              <v-card>
                <v-img
                  gradient="to top left, rgba(0,0,0,0), rgba(0,0,0,.7)"
                  aspect-ratio="1"
                  :lazy-src="imageUrl"
                  :src="imageUrl"
                >
                  <v-layout>
                    <v-btn icon small @click="galleryImageSelected({})">
                      <v-icon color="white"> mdi-close </v-icon>
                    </v-btn>
                  </v-layout>
                </v-img>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-checkbox
              v-model="markReviewed"
              hide-details
              label="Mark content as reviewed and schedule."
            />
          </v-layout>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          <span v-if="markReviewed"> Schedule </span>
          <span v-else> Save </span>
        </v-btn>
      </v-card-actions>
    </v-card>
    <time-and-date-select-dialog
      @onDateSelected="onExpiryDateSelected"
      ref="ExpiryTimeAndDateDialogRef"
    />
    <time-and-date-select-dialog
      @onDateSelected="onScheduleDateSelected"
      ref="ScheduleTimeAndDateDialogRef"
    />
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapActions, mapState, mapGetters } from 'vuex';
import firebase from 'firebase';
import _ from 'lodash';
import { auth } from '@/plugins/firebase';
import moment from 'moment';
import TimeAndDateSelectDialog from './TimeAndDateSelectDialog.vue';
import GalleryImageSelectSection from '@/modules/Assets/components/GalleryImageSelectSection';

export default {
  props: {
    selectedRegion: {
      type: Object,
      default: function() {
        return {};
      },
    },
    collection: {
      type: String,
      default: function() {
        return {};
      },
    },
  },
  components: {
    TimeAndDateSelectDialog,
    // ImageUploadSection,
    GalleryImageSelectSection,
  },
  data() {
    return {
      rules: [(v) => v.length <= 150 || 'Max 150 characters'],
      igPermLink: '',
      expiryRange: '',
      markReviewed: false,
      dialog: false,
      searchTerm: '',
      loading: false,
      dialogAction: '',
      scheduleDateDialog: false,
      expiryDateDialog: false,
      scheduledAtDateField: '',
      expiresAtDateField: '',
      scheduledAt: '',
      expiresAt: '',
      region: {},
      entity: {},
      createdBy: '',
      content: '',
      bgColor: '',
      iconColor: '',
      iconName: '',
      iconType: '',
      isMarker: true,
      location: {},
      firebaseUrl: '',
      imageThumbnail: '',
      imageUrl: '',
      state: '',
      pinType: '',
      id: '',
      linkName: '',
      linkUrl: '',
      attachment: '',
      selectedFromGallery: false,
      hasCustomLocation: false,
      latitude: 0,
      longitude: 0,
    };
  },
  computed: {
    ...mapState('$_home', ['regions']),
    ...mapState('$_entity', ['reviewedEntities']),
    ...mapGetters({
      pinTypes: '$_home/pinTypes',
    }),
    expiryRanges() {
      return this.scheduledAtDateField
        ? ['6 Hours', '12 Hours', '18 Hours', '24 Hours']
        : [];
    },
    scheduledAtDateString() {
      if (this.scheduledAtDateField) {
        return this.iMoment(this.scheduledAtDateField);
      } else {
        return this.scheduledAt;
      }
    },
    expiresAtDateString() {
      if (this.expiresAtDateField) {
        return this.iMoment(this.expiresAtDateField);
      } else {
        return this.expiresAt;
      }
    },
    changeFieldsCopy() {
      return {
        scheduledAt: this.iMoment(this.scheduledAtDateField),
        state: 'scheduled',

        type: 'pin',
        region: this.region,
        createdBy: {
          id: auth.currentUser.uid,
          email: auth.currentUser.email,
          name: auth.currentUser.displayName,
        },
        content: {
          text: this.content,
        },
        entity: this.entity,
        pinType: this.pinType,
        data: {
          title: this.entity.title,
          subTitle: this.entity.subTitle ? this.entity.subTitle : '',
          expiresAt: this.iMoment(this.expiresAtDateString),
          content: this.content,
          createdBy: auth.currentUser.uid,
          graphics: {
            entity: this.pinType.name,
            logoUrl: this.pinType.logo ? this.pinType.logo : '',
            displayPriority: this.pinType.displayPriority
              ? this.pinType.displayPriority
              : Number(0),
            icon: {
              bgColor: this.pinType.backgroundColor,
              color: this.pinType.fontColor,
              name: this.pinType.fontName,
              type: this.pinType.fontFamily,
            },
          },
          image: this.imageUrl
            ? {
                firebaseUrl: this.firebaseUrl,
                thumbnail: this.imageThumbnail,
                url: this.imageUrl,
              }
            : null,
          link: this.linkUrl
            ? {
                url: this.linkUrl,
                name: this.linkName,
              }
            : null,
          isMarker: this.isMarker,
          location: this.hasCustomLocation
            ? new firebase.firestore.GeoPoint(
                parseFloat(this.latitude),
                parseFloat(this.longitude),
              )
            : this.entity.location,
          score: Number(0),

          totalComments: Number(0),
          type: this.pinType.name,
          views: Number(0),
          showInFeed: true,
          entityId: this.entity.id,
          hasProfile: this.entity.hasProfile ? this.entity.hasProfile : false,
          tags: this.entity.tags,
          facebook: this.entity.facebook,
          instagram: this.entity.instagram,
          website: this.entity.website,
          phone: this.entity.phone,
          address: this.entity.address,
        },
      };
    },
    changeFields() {
      return {
        id: this.id,
        scheduledAt: this.iMoment(this.scheduledAtDateField),
        state: this.markReviewed ? 'scheduled' : this.state,

        type: 'pin',
        region: this.region,
        entity: this.entity,
        pinType: this.pinType,
        content: {
          text: this.content,
        },
        data: {
          title: this.entity.title,
          subTitle: this.entity.subTitle ? this.entity.subTitle : '',
          expiresAt: this.iMoment(this.expiresAtDateString),
          content: this.content,
          createdBy: auth.currentUser.uid,
          graphics: {
            entity: this.pinType.name,
            logoUrl: this.pinType.logo ? this.pinType.logo : '',
            displayPriority: this.pinType.displayPriority,
            icon: {
              bgColor: this.pinType.backgroundColor,
              color: this.pinType.fontColor,
              name: this.pinType.fontName,
              type: this.pinType.fontFamily,
            },
          },
          image: this.imageUrl
            ? {
                firebaseUrl: this.firebaseUrl,
                thumbnail: this.imageThumbnail,
                url: this.imageUrl,
              }
            : null,
          link: this.linkUrl
            ? {
                url: this.linkUrl,
                name: this.linkName,
              }
            : null,
          isMarker: this.isMarker,
          location: this.hasCustomLocation
            ? new firebase.firestore.GeoPoint(
                parseFloat(this.latitude),
                parseFloat(this.longitude),
              )
            : this.entity.location,
          score: Number(0),

          totalComments: Number(0),
          type: this.pinType.name,
          views: Number(0),
          showInFeed: true,
          entityId: this.entity.id,
          hasProfile: this.entity.hasProfile ? this.entity.hasProfile : false,
          tags: this.entity.tags,
          facebook: this.entity.facebook,
          instagram: this.entity.instagram,
          website: this.entity.website,
          phone: this.entity.phone,
          address: this.entity.address,
        },
      };
    },
  },

  watch: {
    searchTerm: _.debounce(function(e) {
      e && this.searchEntities(e);
    }, 300),
  },
  mounted() {
    this.getRegions({ collection: 'regions', mutation: 'updateRegions' });
    // this.getEntityTypes({
    //   collection: "entityTypes",
    //   mutation: "updateEntityTypes",
    // });
    this.getPinTypes({ collection: 'pinTypes', mutation: 'updatePinTypes' });
  },
  methods: {
    ...mapActions({
      createNewPin: '$_content/createNewContent',
      getDataStream: '$_content/getDataStream',
      getDataStreamByRegion: '$_content/getContentByRegion',
      updateStreamItem: '$_content/updateStreamItem',
      deleteDataStreamItem: '$_content/deleteContent',
      getRegions: '$_home/getContent',

      //uploadImage: "$_content/uploadImage",
      getPinTypes: '$_home/getContent',

      getEntityTypes: '$_home/getContent',

      searchEntitiesAction: '$_entity/searchContent',
    }),
    entitySelected(entity) {
      console.log('Selected Entity: ', entity);
      if (entity) {
        // this.pinType = entity.default ? entity.default.pinType : {};
        this.linkUrl = entity.default ? entity.default.linkUrl : '';
        this.linkName = entity.default ? entity.default.linkName : '';
        this.latitude = entity.location.latitude;
        this.longitude = entity.location.longitude;
        this.region = entity.region;
      } else {
        this.latitude = 0;
        this.longitude = 0;
      }
    },
    downloadItem({ url, label }) {
      axios
        .get(url, { responseType: 'blob' })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = label;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },
    galleryImageSelected(image) {
      this.selectedFromGallery = image ? true : false;
      this.imageUrl = image.url;
      this.firebaseUrl = image.firebaseUrl ? image.firebaseUrl : '';
      this.imageThumbnail = image.thumbnail;
    },
    // openImageGallery() {
    //   this.$refs.imageGalleryRef.toggleDialog();
    // },
    searchEntities(searchTerm) {
      this.loading = true;
      console.log('searching Tags: ', searchTerm);

      this.searchEntitiesAction({
        collection: 'entities',
        mutation: 'updateReviewedEntities',
        searchTerm: searchTerm,
      }).then(() => {
        this.loading = false;
      });
    },
    iMoment(date) {
      if (date) {
        // console.log(date);
        return moment(date).toDate();
      }
      return new Date();
    },
    toggleDialog(details, action) {
      this.dialog = !this.dialog;
      if (this.dialog) {
        console.log('Edit Details: ', details);

        this.dialogAction = action;
        this.id = details.id;
        this.igPermLink = details.IGPermLink ? details.IGPermLink : '';
        this.scheduledAtDateField = details.scheduledAt
          ? details.scheduledAt.seconds * 1000
          : '';
        // this.expireAtDateField = details.data.expiresAt.seconds * 1000;
        this.scheduledAt = details.scheduledAt
          ? this.iMoment(details.scheduledAt.seconds * 1000)
          : '';
        this.expiresAt = details.data
          ? details.data.expiresAt
            ? this.iMoment(details.data.expiresAt.seconds * 1000)
            : ''
          : '';
        this.state = details.state ? details.state : '';
        this.region = details.region ? details.region : details.entity.region;
        this.entity = details.entity ? details.entity : {};
        this.pinType = details.pinType ? details.pinType : {};
        this.content = details.data
          ? details.data.content
          : details.content.text
          ? details.content.text
          : '';
        this.bgColor = details.data ? details.data.graphics.icon.bgColor : '';
        this.iconColor = details.data ? details.data.graphics.icon.color : '';
        this.iconName = details.data ? details.data.graphics.icon.name : '';
        this.iconType = details.data ? details.data.graphics.icon.type : '';
        //   this.isMarker = true;
        this.linkUrl = details.data
          ? details.data.link
            ? details.data.link.url
            : ''
          : '';
        this.linkName = details.data
          ? details.data.link
            ? details.data.link.name
            : ''
          : '';

        this.hasCustomLocation = details.hasCustomLocation
          ? details.hasCustomLocation
          : false;
        if (details.hasCustomLocation) {
          this.latitude = details.data.location.latitude;
          this.longitude = details.data.location.longitude;
        } else {
          console.log('Location: ', details);
          this.location = details.data
            ? details.data.location
            : details.entity.location;

          this.latitude = details.data
            ? details.data.location.latitude
            : details.entity.location.latitude;
          this.longitude = details.data
            ? details.data.location.longitude
            : details.entity.location.longitude;
        }
        this.imageThumbnail = details.data
          ? details.data.image
            ? details.data.image.thumbnail
            : ''
          : details.content.image
          ? details.content.image.thumbnail
          : '';
        this.firebaseUrl = details.data
          ? details.data.image
            ? details.data.image.firebaseUrl
              ? details.data.image.firebaseUrl
              : ''
            : ''
          : '';

        this.imageUrl = details.data
          ? details.data.image
            ? details.data.image.url
            : ''
          : details.content.image
          ? details.content.image.url
          : '';
        this.attachment = details.content.attachment
          ? details.content.attachment
          : '';
      }
    },
    openExpiryDateDialog() {
      this.$refs.ExpiryTimeAndDateDialogRef.toggleDialog(
        this.expiresAtDateField,
      );
    },
    // onExpiryDateSelected(dateTime) {
    //   // console.log("Expiry Selected Date and Time: ", dateTime);
    //   this.expiresAtDateField = dateTime;
    // },
    onExpiryDateSelected(timeRange) {
      console.log('Expiry Selected time range: ', timeRange);
      switch (timeRange) {
        case '6 Hours':
          this.expiresAtDateField = moment(this.scheduledAtDateField).add(
            6,
            'hours',
          );
          break;
        case '12 Hours':
          this.expiresAtDateField = moment(this.scheduledAtDateField).add(
            12,
            'hours',
          );
          break;
        case '18 Hours':
          this.expiresAtDateField = moment(this.scheduledAtDateField).add(
            18,
            'hours',
          );
          break;
        case '24 Hours':
          this.expiresAtDateField = moment(this.scheduledAtDateField).add(
            24,
            'hours',
          );
          break;
        default:
          this.expiresAtDateField = this.scheduledAtDateField;
      }
      // this.expiresAtDateField = dateTime;
      // console.log(this.expiresAtDateField);
    },
    openScheduleDateDialog() {
      this.$refs.ScheduleTimeAndDateDialogRef.toggleDialog(
        this.scheduledAtDateField,
      );
    },
    onScheduleDateSelected(dateTime) {
      // console.log("Scheduled Selected Date and Time: ", dateTime);
      this.scheduledAtDateField = dateTime;
      this.expiryRange = '6 Hours';
      this.onExpiryDateSelected(this.expiryRange);
    },
    cancel() {
      this.scheduledAtDateField = '';
      this.expiresAtDateField = '';
      this.scheduledAt = '';
      this.region = '';
      this.state = '';
      this.region = {};
      this.entity = {};
      this.createdBy = '';
      this.content = '';
      this.bgColor = '';
      this.iconColor = '';
      this.iconName = '';
      this.iconType = '';
      this.isMarker = true;
      this.location = {};
      this.imageThumbnail = '';
      this.imageUrl = '';
      this.pinType = {};
      this.id = '';
      this.linkUrl = '';
      this.linkName = '';

      if (this.selectedFromGallery == true) {
        this.$refs.galleryImageSelectSectionRef.galleryImageDeselect();
      }

      this.selectedFromGallery = false;
      this.hasCustomLocation = false;
      this.latitude = 0;
      this.longitude = 0;

      this.dialog = false;
    },
    save() {
      console.log('edited Pin: ', this.changeFields);
      console.log('Reviewed', this.markReviewed);
      if (this.markReviewed) {
        if (!this.scheduledAtDateString) {
          alert('Yo yo, Slow down dude, add a Scheduled At time');
          return;
        }
        console.log('edited Pin: ', this.changeFields);
        this.createNewPin({
          details: this.changeFieldsCopy,
          collection: this.collection,
          type: 'Pin',
        }).then(() => {
          this.updateStreamItem({
            details: this.changeFields,
            collection: 'datastream',
          }).then(() => {
            this.cancel();
            this.getDataStream();
          });
        });
      } else {
        this.updateStreamItem({
          details: this.changeFields,
          collection: 'datastream',
        }).then(() => {
          this.cancel();
          this.getDataStream();
        });
      }
    },
  },
};
</script>

<style></style>
